import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import * as SolidIcons from "@fortawesome/free-solid-svg-icons";
import * as RegularIcons from "@fortawesome/free-regular-svg-icons";
import { GenericIcon } from "../model/shared/types/GenericIcon";

const getIconsMap = (icons: typeof SolidIcons | typeof RegularIcons) => {
  return Object.values(icons)
    .filter((icon): icon is IconDefinition =>
      Boolean((icon as IconDefinition)?.iconName),
    )
    .reduce<Record<string, IconDefinition>>((acc, icon) => {
      acc[icon.iconName] = icon;
      return acc;
    }, {}) as Record<string, IconDefinition>;
};

const solidIconMap = getIconsMap(SolidIcons);
const regularIconMap = getIconsMap(RegularIcons);

export function getFontAwesomeIcon(icon?: GenericIcon): IconDefinition | null {
  if (!icon || !["fas", "far"].includes(icon.prefix)) {
    return null;
  }

  if (icon.prefix === "fas") {
    return solidIconMap[icon.name];
  }

  if (icon.prefix === "far") {
    return regularIconMap[icon.name];
  }

  return null;
}
